module.exports = __webpack_public_path__ + "static/media/PSLDisplayPro.dc2e07a5.svg";